<template>
    <div
        v-if="activePath.steps"
        class="o-ar-view"
    >
        <MotionStack
            v-if="isArEnabled"
            @gyro="onGyro"
            @compas="onCompass"
            @stepForward="onStepForward"
        />
        <MCameraVideo v-if="isArEnabled" />
        <MArDistance
            :distance="activeStepDistance"
            :stepsCount="stepsCount"
        />
        <MArArrow
            v-if="arrowDirection!==null"
            :arrowDirection="arrowDirection"
            :compassDirection="compassDegree"
            :directionDiff="directionDiff"
            :distance="activeStepDistance"
            :stepsCount="stepsCount"
            :gyro="gyro"
        />
        <button
            type="button"
            class="ar-view-full-screen-button"
            @click="handleFullScreen"
        />
        <button
            type="button"
            class="ar-view-close-button"
            @click="handleCloseClick"
        />
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';

import MArArrow from "@/components/molecules/m-ar-arrow";
import MotionStack from "@/components/external/motion-stack/motion-stack";
import MCameraVideo from "@/components/molecules/m-ar-camera-video/m-camera-video";
import MArDistance from "@/components/molecules/m-ar-diastance/m-ar-distance";

export default {
    name: 'OArView',
    components: {
        MArDistance,
        MArArrow,
        MotionStack,
        MCameraVideo
    },
    data() {
        return {
            gyro: null,
            stepsCount: 0,
            compassDirection: 0,
            isArActive: false,
        }
    },
    props: {
        compassDegree: {
            type: Number,
            default: 0
        },
        isArEnabled: {
            type: Boolean,
            default: false
        }
    },
    computed:{
        ...mapGetters([
            'getMapConfigProp',
        ]),
        ...mapState({
            activeStepDistance: state => Math.round( state.activeStep?.distance || 0), //world_distance
            isCompassEnabled: state => state.isCompassEnabled,
            activeStepIndex: state => state.activeStepIndex,
            activePath: state => state?.activePath || false,
            activeStep: state => state.activeStep,
        }),
        compassCorrectionValue() {
            return this.getMapConfigProp('compass_correction', 0);
        },
        arrowDirection(){
            let arrowDirection = 0;

            if (!this.activePath) return 0;

            if(this.activeStepIndex){
                const index = this.activeStep?.vertex_index;
                const vertexes = this.activePath?.vertices || [];

                let vertex = index in vertexes && vertexes[index];

                if(!vertex)
                {
                    vertex = index in vertexes && vertexes[index];
                }

                if(!vertex)  return 0;

                arrowDirection = vertex.world_orientation;
            }
            else{
                arrowDirection = this.activePath?.vertices[0].world_orientation
            }
            //arrowDirection-=10;
            arrowDirection+=this.compassCorrectionValue;// + 90;

            return arrowDirection;
        },
        directionDiff(){
            const initial = this.compassDegree;
            let final = this.arrowDirection;
            if (final < 0) { final += 360; }
            if (final > 360) { final -= 360; }

            if (initial > 360 || initial < 0 || final > 360 || final < 0)
            {
                // alert(initial +' '+ final);
            }

            const diff = final - initial;
            const absDiff = Math.abs(diff);

            if (absDiff <= 180)
            {
                return absDiff == 180 ? absDiff : diff;
            }

            else if (final > initial)
            {
                return absDiff - 360;
            }
            else
            {
                return 360 - absDiff;
            }
        },
    },
    methods:{
        onCompass(direction){
            this.compassDirection = direction;
        },
        onGyro(gyro){
            this.gyro = gyro;
        },
        onStepForward(){
            if(this.directionDiff < 30 && this.directionDiff > -30)
                this.stepsCount+=1;
        },
        activateAr(){
            this.isArActive = true;
        },
        handleCloseClick() {
            this.$emit('closeArView');
        },
        handleFullScreen() {
            this.$emit('onArFullScreen');
        }
    },
    watch:{
        activeStepIndex(){
            this.stepsCount = 0;
        }
    }
}
</script>

<style lang="scss" src="./o-ar-view.scss" />
